import cronstrue from 'cronstrue'

const transformToExpression = cron => cronstrue.toString(cron)

export default transformToExpression
